<template>
  <div class="contenido">
    <v-card class="elevation-6" style="opacity:0.8;">
      <v-card-text>
        <v-layout row wrap class="my-2">
          <v-tooltip color="primary" top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' color="primary" x-large @click="$root.$emit('onOpcionPortal', 'principal')">keyboard_backspace</v-icon>
            </template>
            <span>Ir atrás</span>
          </v-tooltip>
          <v-spacer/>
          <span class="primary--text">
            <h3><v-icon class="my-1" color="primary">info</v-icon>&nbsp;Información</h3>
          </span>
          <v-spacer/>
        </v-layout>
        <span class="primary--text">
          <v-icon color="primary">info</v-icon>&nbsp;RECUERDE
        </span>
        <br>
        <p align='justify'>
          La Declaración Jurada de Bienes y Rentas debe ser presentada por las servidoras y los servidores públicos, según corresponda, en los siguientes plazos:
        </p>
        <p align='justify'>
          1. Antes del ejercicio del cargo: Hasta el primer día hábil de inicio de funciones.
        </p>
        <p align='justify'>
          2. Durante el ejercicio del cargo:
          <ul>
            <li>Si la persona reside en una capital de departamento, debe presentarla durante el mes de su nacimiento.</li>
            <li>Si reside fuera de una capital de departamento, cuenta además con el mes siguiente a su mes de nacimiento para cumplir con esta obligación.</li>
          </ul>
        </p>
        <p align='justify'>
          3. Después del ejercicio del cargo: Hasta 30 días calendario, computados desde el primer día de su desvinculación.
        </p>
        <p align='justify'>
          Esta obligación está establecida en el Decreto Supremo N.º 1233, Capítulo I, Artículo 4 y 5.
        </p>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="black--text">
              <b>¿NECESITA MÁS AYUDA? RECURSOS DISPONIBLES</b>
            </span><br><br>

            <span class="black--text">
              <b>Cartilla y Manuales</b>
            </span><br>
            <ul>
              <li>
                <a href="https://www.contraloria.gob.bo/wp-content/uploads/2024/10/Cartilla_Educativa_No001_DJBR-peq.pdf" target="_blank">Cartilla informativa de la Declaración Jurada de Bienes y Rentas&nbsp;<v-icon>get_app</v-icon></a><br>
                Resumen práctico con los aspectos más importantes del proceso.
              </li>
              <li>
                <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/qbxkg6tp56DseHo" target="_blank">Manual de Usuario - Modalidad Tradicional (Física)&nbsp;<v-icon>get_app</v-icon></a><br>
                Guía detallada para el llenado manual del formulario DJBR.
              </li>
              <li>
                <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/mNnYJjxba47Zj5g" target="_blank">Manual de Usuario - Modalidad Digital (DJBR Digital)&nbsp;<v-icon>get_app</v-icon></a><br>
                Instructivo paso a paso para realizar la declaración en línea.
              </li>
            </ul>
            <span class="black--text">
              <b>Videos Tutoriales e Informativos</b>
            </span><br>
            <ul>
              <li>
                <a href="https://www.youtube.com/watch?v=l3bigxW9v60" target="_blank">Video Informativo sobre la Declaración Jurada de Bienes y Rentas&nbsp;<v-icon>get_app</v-icon></a><br>
                Información general sobre la DJBR  y aspectos más importantes.
              </li>
              <li>
                <a href="https://www.youtube.com/watch?v=ZfjoGPTYPcw" target="_blank">Video Tutorial: Cómo llenar la Declaración Jurada de Bienes y Rentas Digital&nbsp;<v-icon>get_app</v-icon></a><br>
                Demostración paso a paso del llenado en la plataforma digital.
              </li>   
            </ul>
          </v-flex>
        </v-layout>
        <br><br>
        <v-layout row wrap>
          <v-flex xs12>
          <span class="primary--text">
            <b><v-icon color="primary">settings_phone</v-icon>&nbsp;&nbsp;TELÉFONOS DE CONSULTA - WHATSAPP</b>
          </span>
          <br>
          <br>
          <p>Puede realizar consultas o enviar solicitudes mediante mensajes de texto, por WhatsApp a los siguientes números: </p>
          <div id="tabla1">
            <table>
              <thead>
                <tr id="cabtab1">
                  <th>
                    <v-icon>edit</v-icon>&nbsp;&nbsp;Consultas Whatsapp
                  </th>
                  <th>
                    <v-icon>mdi-cellphone</v-icon>&nbsp;&nbsp;N° Celular
                  </th>
                </tr>
              </thead>
              <tbody id="cuerpotab1">
                <tr>
                  <td>Bajas y/o Exclusiones :</td>
                  <td>60512947</td>
                </tr>
                <tr>
                  <td>Certificados de Información Sobre Solvencia con el Fisco :</td>
                  <td>62462052</td>
                </tr>
                <tr>
                  <td>Registro de Procesos y Contratos :</td>
                  <td>62414400</td>
                </tr>
                <tr>
                  <td>Declaración Jurada de Bienes y Rentas :</td>
                  <td>62415396</td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-flex>
        <v-flex xs12>
          <br><br>
          <span class="primary--text">
            <b><v-icon color="primary">settings_phone</v-icon>&nbsp;&nbsp;CONSULTAS TELEFÓNICAS – LÍNEA FIJA</b>
          </span>
          <p class="mt-2">También puede comunicarse al teléfono fijo de la ciudad de La Paz: 2177400, a los siguientes internos: </p>
          <div id="tabla1">
            <table>
              <thead>
                <tr id="cabtab1">
                  <th>
                    <v-icon>call</v-icon>&nbsp;&nbsp;Telf. La Paz 2177400
                  </th>
                  <th>
                    <v-icon>mdi-cellphone</v-icon>&nbsp;&nbsp;Interno
                  </th>
                </tr>
              </thead>
              <tbody id="cuerpotab1">
                <tr>
                  <td>Bajas y/o Exclusiones :</td>
                  <td>Int. 550</td>
                </tr>
                <tr>
                  <td>Certificados de Información Sobre Solvencia con el Fisco :</td>
                  <td>Int. 514 - 519</td>
                </tr>
                <tr>
                  <td>Registro de Procesos y Contratos :</td>
                  <td>Int. 514 - 519</td>
                </tr>
                <tr>
                  <td>Declaración Jurada de Bienes y Rentas :</td>
                  <td>Int. 607-770-716</td>
                </tr>
              </tbody>
            </table>
          </div>
      </v-flex>
      </v-layout>
      <br><br><br><br>
      </v-card-text>    
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'ayuda',
  data () {
    return {};
  },
  methods: {
    descargarArchivoPdf (dato) {
      let urlArchivo = '';
      let usuario = 'portal';
      let nombreUsuario = 'usuario_portal';
      switch (dato) {
        case 0: urlArchivo = 'archivo_predefinido/manual_djbrd_tradicional_externo';
          break;
        case 1: urlArchivo = 'archivo_predefinido/manual_djbrd_digital_externo';
          break;
        case 2: urlArchivo = 'archivo_predefinido/guia_registro_djbr';
          break;
        case 3: urlArchivo = 'archivo_predefinido/cartilla_djbr';
          break;
      }
      this.$service.get(`${urlArchivo}/${usuario}/${nombreUsuario}`).then(response => {
        if (response) {
          this.downloadPDF(response.documento, response.nombre);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>
<style scoped>
#tabla1 {
  border: 1px solid #98d1fd;
  width: 100%;
  max-width: 500px;
  margin: auto;
  border-collapse: collapse; 
  float: left;
}

#cabtab1 {
  background-color: #01579b;
  font-weight: bold;
  color: #ffffff;
  text-align: left; 
}

#cuerpotab1 tr {
  background-color: #ecece5;
}

#cuerpotab1 tr:nth-child(even) {
  background-color: #f7f7f7; 
}

#tabla1 th, #tabla1 td {
  padding: 10px; 
  text-align: left; 
  border: 1px solid #98d1fd; 
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/Informacion.vue